/*
Author : Arman Ali
Module: create Vehicle
github: https://github.com/Arman-Arzoo
*/
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem} from '@mui/material';
import { useEffect } from 'react';
import RemoveDriver from './RemoveDriver';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddDriver, UpdateDriver } from '../../../../../reduxToolkit/Vehicle/VehicleApi';
import {Driver, VehiclePermissionTypeModel} from '../../../../../models/Driver';
import CustomModal from '../../../../../components/Modal/CustomModal';
import {CustomTextField} from '../../../../../components/CustomTextField';
import {CustomSelectAndChildren} from '../../../../../components/CustomSelectAndChildren';
import {CustomDatePicker} from '../../../../../components/CustomDatePicker';
import {ButtonPrevStep} from '../../../../../components/buttons/ButtonNavigation';
import {toast} from 'react-toastify';
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

/**
 * @param id: id of the current vehicle details
 * @param data: data of current card driver
 * @param setData
 * @param title: title of your modal
 * @param checkmodal: checkmodal is other add or update
 * @param show
 * @param updateDriver
 * @param onHide
 * @returns {JSX.Element}
 * @constructor
 */
const DriverModal = (props) => {
    const { id, data, setData, title, checkmodal, show, updateDriver, onHide } = props;

    // use hook
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [showDriver, setShowDriver] = useState(false);
    const [showDatePickers, setShowDatePickers] = useState(true);

    const [driver, setDriver] = useState({ ...Driver, vehicleId: id, id: data?.id ? data.id : null });
    const [emptyFields, setEmptyFields] = useState(false);
    const [emptyFieldsDate, setEmptyFieldsDate] = useState(false);
    const [isValidFrom, setIsValidFrom] = useState(true);
    const [isValidTo, setIsValidTo] = useState(true);
    const { premmissionType } = useSelector((state) => state.VehicleSlice);
    const [selectedList, setSelectedList] = useState([]);

    //reset
    const reset = () => {
        setDriver({ ...Driver, vehicleId: id, id: data?.id ? data.id : null});
    };

    const isValid2 = () => {
        return driver.from !== null && driver.to !== null &&
            driver.userId !== '' && driver.userId != null &&
            driver.vehiclePermissionTypeId !== '' && driver.vehiclePermissionTypeId != null && isValidFrom && isValidTo
    }
    const isValid1 = () => {
        return driver.userId !== '' && driver.userId != null &&
            driver.vehiclePermissionTypeId !== '' && driver.vehiclePermissionTypeId != null
    }

    const addEditDriver = () => {
        dispatch(checkmodal == 'update' ? UpdateDriver(driver.toCreateUpdate()) : AddDriver(driver.toCreateUpdate()));
        reset();
        props.onHide();
        toast.success(t(checkmodal == 'update' ? 'has_been_updated_successfully': 'has_been_created_successfully' ).toUpperCase());
    }

    // handel driver function
    const handleDriver = () => {
        if (driver.vehiclePermissionTypeId == VehiclePermissionTypeModel.TEMPORAL.id) {
            if(!isValid2()){
                setEmptyFieldsDate(true);
                setEmptyFields(true);
                return;
            }
            setEmptyFieldsDate(false);
            setEmptyFields(false);
            addEditDriver();
        } else {
            if(!isValid1()){
                setEmptyFields(true);
                return;
            }
            setEmptyFields(false);
            addEditDriver();
        }
    };

    useEffect(() => {
        if(selectedList?.length > 0){
            setDriver((prevData) => ({
                ...prevData,
                userId: selectedList[0]?.id,
            }));
        }
    },[selectedList]);

    const handleFromDateChange = (selectedDate) => {
        setDriver((prevData) => ({
            ...prevData,
            from: selectedDate,
        }));
    };

    const handleToDateChange = (selectedDate) => {
        setDriver((prevData) => ({
            ...prevData,
            to: selectedDate,
        }));
    };

    const handlePermissionTypeChange = (e) => {
        setDriver((prevData) => ({
            ...prevData,
            vehiclePermissionTypeId: e.target.value,
        }));
    };

    useEffect(() => {
        if (driver?.to && driver?.from) {
            const fromDate = new Date(driver.from).getTime();
            const toDate = new Date(driver.to).getTime();
            if (toDate < fromDate) {
                setIsValidTo(false);
            } else {
                setIsValidTo(true);
            }
        }
    }, [driver?.to, driver?.from]);

    /**
     * This `useEffect` hook runs whenever `driver.vehiclePermissionTypeId` changes.
     * If the `vehiclePermissionTypeId` is equal to 1, it resets the `to` and `from` properties
     * in the driver's state to `null`, while keeping the rest of the driver's state unchanged.
     */
    useEffect(() => {
        if (driver.vehiclePermissionTypeId == 1) {
            setDriver((prevData) => ({
                ...prevData,
                to: null,
                from: null,
            }));
        }
        setShowDatePickers(driver.vehiclePermissionTypeId != 1);
        setEmptyFieldsDate( false);
    }, [driver?.vehiclePermissionTypeId]);

    // dispatch to get result
    useEffect(() => {
        setEmptyFields(false);
        if (checkmodal === 'update') {
            setDriver({
                ...Driver,
                vehicleId: id,
                id: data.id,
                from: data?.from || null,
                to: data?.to || null,
                vehiclePermissionTypeId: data?.vehiclePermissionTypeId || '',
            });
        } else {
            setDriver({ ...Driver, vehicleId: id });
        }
        setIsValidFrom(true);
        setIsValidTo(true);
    }, [props.show]);

    return (
        <>
            <CustomModal
                title={title}
                size='lg'
                {...props}
                onConfirm={() => {
                    handleDriver();
                }}
            >
                <div className='row'>
                    {checkmodal != 'update' ?
                        <div className='col-12'>
                            <CustomAddChipSearch
                                autocompleteId={'slt_dm_employee'}
                                buttonId={'btn_acm_employee'}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                                userTypeIdsSearch={[USER_TYPE_MODEL.EMPLOYEE]}
                                disabled={false}
                                label="employee"
                                emptyFields={(emptyFields)}
                                required={true}
                                reset={false}
                                hideButton={true}
                                keyId={"userId"}
                                showRenderOption={true}
                                maxLength={1}
                                showSubSection={true}
                                sanitizeDataList={userListToLabelEmailPhoneValue}
                                Icon={PersonChipBlack}
                            />
                        </div>
                        :
                        <div className='col-12'>
                            <CustomTextField
                                id='slt_dm_employee'
                                length={128}
                                name='name'
                                value={`${data?.name || ''} ${data?.lastName || ''} ${data?.secondLastName || ''}`.trim()}
                                trans={"employee"}
                                type={"text"}
                                disabled={true}
                            />
                        </div>
                    }
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren id={"slt_dv_vehicle_permission_type_id"}
                                                 name={"vehiclePermissionTypeId"}
                                                 trans={"permission_type"}
                                                 value={driver.vehiclePermissionTypeId || ''}
                                                 onChange={(e)=>{
                                                     handlePermissionTypeChange(e);
                                                 }}
                                                 required={true}
                                                 emptyFields={emptyFields}
                        >
                            {premmissionType?.map((item) => {
                                return <MenuItem id={item.id} value={item.id}>{item.name}</MenuItem>;
                            })}
                        </CustomSelectAndChildren>
                    </div>
                    {showDatePickers &&
                        <>
                            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                                <CustomDatePicker
                                    id={"dp_dm_from"}
                                    name={'from'}
                                    disabled={false}
                                    onChange={(e)=>{
                                        handleFromDateChange(e)
                                    }}
                                    trans={"from"}
                                    value={driver.from}
                                    required={driver.vehiclePermissionTypeId == VehiclePermissionTypeModel.TEMPORAL.id}
                                    openTo={"day"}
                                    isValid={isValidTo}
                                    emptyFields={emptyFieldsDate}
                                />
                            </div>
                            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                                <CustomDatePicker
                                    id={"dp_dm_to"}
                                    name={'to'}
                                    disabled={driver.from === null}
                                    onChange={(e)=>{
                                        handleToDateChange(e)
                                    }}
                                    trans={"to"}
                                    value={driver.to}
                                    required={driver.vehiclePermissionTypeId == VehiclePermissionTypeModel.TEMPORAL.id}
                                    openTo={"day"}
                                    minDate={driver.from}
                                    isValid={isValidTo}
                                    emptyFields={emptyFieldsDate}
                                />
                            </div>
                        </>
                    }

                    {checkmodal == 'update' &&
                        <div className='col-12'>
                            <ButtonPrevStep
                                id="btn_dm_remove_driver"
                                text={t("remove_driver")}
                                classNameBtn='text-decoration-underline'
                                click={() => {
                                    setShowDriver(true);
                                    onHide();
                                }}
                            />
                        </div>
                    }
                </div>
            </CustomModal>

            {showDriver &&
                <RemoveDriver
                    show={showDriver}
                    data={{
                        id: data?.id,
                        name: `${data?.name || ''} ${data?.lastName || ''} ${data?.secondLastName || ''}`.trim(),
                    }}
                    onHide={() => setShowDriver(false)}
                    title_modal={t('remove_driver')}
                    modal_name='remove_driver'
                />
            }

        </>
    );
};

export default DriverModal;
